export enum RouteToDestinations {
  Courier = 'app.couriers',
  Home = 'app.home',
  Account_Payment = 'app.account.payment',
  Shipments = 'app.shipments',
  Advanced = 'app.multiple',
  Product_Listing = 'app.product-listing',
  PackingSettings = 'app.tools.packing-slip',
  Connect = 'app.connect',
  Printer_Settings = 'printing-options',
  Single_Store = 'app.single-store',
  ManualInput = 'manual-input',
  FileUpload = 'fileUpload',
}
